export const SET_SELECTED_REPORT_FILTERS = "SET_SELECTED_REPORT_FILTERS";
export const RESET_REPORT_FILTERS = "RESET_REPORT_FILTERS";